import { useEffect } from 'react';
import { useRegion, REGIONS } from '../context/RegionContext';
import { useI18n } from '../context/I18nContext';
import { useCurrency } from '../context/CurrencyContext';

/**
 * Lives inside all three providers (Region, I18n, Currency).
 * When the user picks a region (or a region is auto-detected + accepted),
 * this component pushes the region's default language + currency to the
 * corresponding contexts.
 *
 * Individual language/currency selections still win — the region is just a
 * sensible starting point.
 */
export default function RegionSync() {
  const { region } = useRegion();
  const { setLang } = useI18n();
  const { setCurrency } = useCurrency();

  useEffect(() => {
    if (!region) return;
    const entry = REGIONS.find((r) => r.code === region);
    if (!entry) return;
    setLang(entry.lang);
    setCurrency(entry.currency);
    // Intentionally run only when region changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region]);

  return null;
}
